import { withInstall } from '@hd-front-end/utils'
import Switch from './src/switch.vue'

import type { SFCWithInstall } from '@hd-front-end/utils'

export const ElSwitch: SFCWithInstall<typeof Switch> = withInstall(Switch)
export default ElSwitch

export * from './src/switch'
